import { FC, PropsWithChildren } from 'react';

export const If: FC<PropsWithChildren<{ condition: boolean }>> = ({ condition, children }) =>
  condition ? children : null;
